var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from 'react';
import { Header, HeaderDetail, HeaderLabel, CardValue } from './shared';
var CardHeader = function (_a) {
    var row = _a.row, mdDownHeaderDetail = _a.mdDownHeaderDetail, cellDrawerProps = _a.cellDrawerProps, isLoading = _a.isLoading;
    var cells = row.cells;
    var renderDetail = function () {
        var detailCell = cells.find(function (_a) {
            var column = _a.column;
            return column.Header === mdDownHeaderDetail;
        });
        return detailCell === null || detailCell === void 0 ? void 0 : detailCell.render('Cell', cellDrawerProps);
    };
    var _b = __read(cells, 1), cell = _b[0];
    var column = cell.column;
    var header = column.render('Header');
    var displayedHeader = typeof header === 'string' ? "".concat(header, ":") : header;
    var displayHeaderDetail = !isLoading && mdDownHeaderDetail;
    return (React.createElement(Header, null,
        React.createElement(HeaderLabel, null, displayedHeader),
        React.createElement(CardValue, null, !isLoading && cell.render('Cell', cellDrawerProps)),
        displayHeaderDetail && React.createElement(HeaderDetail, null, renderDetail())));
};
export default CardHeader;
//# sourceMappingURL=CardHeader.js.map